// Base configuration for axios
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { getSession, storage } from 'utils';
import configEnv from 'utils/config';

const service: AxiosInstance = axios.create({
  baseURL: configEnv.API_BASE_URL,
  timeout: 60000,
  withCredentials: true,
});

const ENTRY_ROUTE = '/login';
const PUBLIC_REQUEST_KEY = 'public-request';

/* Intercepting the request and checking if the user is logged in. If not, it redirects to the login
page. */

// service.interceptors.request.use(
//   (config: AxiosRequestConfig) => {
//     const jwtToken = storage.getToken();

//     /* Checking if the user is logged in. If not, it redirects to the login page. */
//     if (!jwtToken && !(config as any).headers[PUBLIC_REQUEST_KEY]) {
//       window.location.replace(
//         `${ENTRY_ROUTE}?redirect=${window.location.href.replace(
//           window.location.origin,
//           ''
//         )}`
//       );
//     }

//     /* Checking if the user is logged in. If not, it redirects to the login page. */
//     if (!getSession(jwtToken) && !(config as any).headers[PUBLIC_REQUEST_KEY]) {
//       window.location.replace(
//         `${ENTRY_ROUTE}?redirect=${window.location.href.replace(
//           window.location.origin,
//           ''
//         )}`
//       );
//     }

//     return config;
//   },
//   (error: any) => {
//     Promise.reject(error);
//   }
// );

// API respone interceptor
service.interceptors.response.use(
  (response: AxiosResponse) => response.data,
  (error: any) => Promise.reject(error)
);

export default service;
// export const cytest = () => {};
